export default {"src":"/_next/static/media/a-series-contemporary.b8b6c493.svg","height":1000,"width":1000};